import PluginConfiguration from "./PluginConfiguration";
import PluginItemView from "./PluginItemView";

export default {
    pluginTypeId: 'iframe',
    pluginTypeName: 'External iFrame',
    PluginConfiguration: PluginConfiguration,
    PluginItemView: PluginItemView
}



// WEBPACK FOOTER //
// ./src/components/plugins/iframePlugin/index.js